<template>
  <div>
    <v-card style="max-width: 500px; margin: 0 auto;">
      <v-card-media class="white--text" height="200px" :src="photoURL">
        <v-container fill-height fluid class="name">
          <v-layout fill-height>
            <v-flex xs12 align-end flexbox>
              <span class="headline">{{displayName}}</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-media>
      <v-card-actions>
        <v-btn color="error" block large @click="logout">Logout</v-btn>
      </v-card-actions>
    </v-card>
    <br>
    <v-card style="max-width: 500px; margin: 0 auto;">
      <v-container fill-height fluid>
        <v-layout fill-height>
          <v-flex xs12 align-end flexbox>
            <span class="headline">Google Assistant Settings</span>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-text>
        Default shopping list:
        <v-select :items="lists" v-model="selectedList" label="Select" single-line item-text="title" item-value="id"></v-select>
      </v-card-text>
      <v-card-actions>
        <v-btn color="accent" block large @click="saveAssistantSettings">Save</v-btn>
      </v-card-actions>
    </v-card>
    <p class="version">Version 1.0.4</p>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import { firestore, checkAuth } from '../firestoreConnection';

export default {
  name: 'view-account',
  data() {
    return {
      lists: [],
      selectedList: undefined
    };
  },
  computed: {
    displayName: function() {
      return this.$store.state.user.displayName;
    },
    photoURL: function() {
      return this.$store.state.user.photoURL;
    }
  },
  mounted() {
    checkAuth(this)
      .then(
        function() {
          this.$bind('lists', firestore.collection('lists').where('owner', '==', this.$store.state.user.uid));

          firestore
            .doc(`users/${this.$store.state.user.uid}`)
            .get()
            .then(
              function(data) {
                if (data.exists) {
                  if (data.data().assistant) {
                    if (data.data().assistant.googleAssistant) {
                      if (data.data().assistant.googleAssistant.defaultList) {
                        this.selectedList = data.data().assistant.googleAssistant.defaultList;
                      }
                    }
                  }
                }
              }.bind(this)
            );
        }.bind(this)
      )
      .catch(
        function() {
          this.$router.push('/login');
        }.bind(this)
      );
  },
  methods: {
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(function() {
          this.$router.push('/login');
        }.bind(this));
    },
    saveAssistantSettings: function() {
      firestore.doc(`users/${this.$store.state.user.uid}`).update({
        assistant: {
          googleAssistant: {
            defaultList: this.selectedList
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.name {
  background-color: rgba(0, 0, 0, 0.5);
}

.version {
  text-align: center;
  padding: 15px;
  color: darkgray;
}
</style>
